import Randomizer from "../../../../src/docs/components/randomizer";
import ClientRandomizer from "../../../../src/docs/components/clientrandomizer";
import DracBanner from "../../../../src/docs/assets/title-image.jpg";
import Zoom from 'react-reveal/Zoom'; // Importing Zoom effect

import Sponsor from "../../../../src/docs/assets/bw-academy.jpg";
import SnowTitle from "../../../../src/docs/assets/english-title-page.jpg";
import SnowSpanishTitle from "../../../../src/docs/assets/spanish-title-pix.jpg";
import FlyingFoy from "../../../../src/docs/assets/flying-by-foy.svg";
import FlyingFoySpanish from "../../../../src/docs/assets/flying-by-foy-spanish.svg";
import * as React from 'react';
export default {
  Randomizer,
  ClientRandomizer,
  DracBanner,
  Zoom,
  Sponsor,
  SnowTitle,
  SnowSpanishTitle,
  FlyingFoy,
  FlyingFoySpanish,
  React
};